'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _containers = require('containers');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = exports.App = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    (0, _classCallCheck3.default)(this, App);
    return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
  }

  (0, _createClass3.default)(App, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          subHeader = _props.subHeader,
          children = _props.children,
          navBar = _props.navBar;

      var styles = require('./App.scss');
      var logo = require('./travelport-redefining-logo.png');

      return _react2.default.createElement(
        'div',
        { className: styles.root },
        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
        _react2.default.createElement(_containers.NotificationSystem, null),
        _react2.default.createElement(_containers.LoadingOverlay, null),
        _react2.default.createElement(_containers.Modals, null),
        _react2.default.createElement(
          'div',
          { className: 'inner-scroll-layout' },
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('inner-scroll-wrapper', styles.wrapper) },
            _react2.default.createElement(
              'div',
              { className: 'inner-scroll-fixed' },
              _react2.default.createElement(_components.EnterpriseHeader, {
                className: styles.header,
                logo: logo,
                homeUrl: _config2.default.app.homeUrl
              }),
              _react2.default.createElement(_components.EnterpriseNavBar, { className: styles.navBar, navBar: navBar }),
              subHeader && _react2.default.createElement(
                _components.EnterpriseSubHeader,
                { className: styles.subHeader },
                subHeader
              )
            ),
            _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)('inner-scroll-scrollable', styles.contentWrapper) },
              _react2.default.createElement(
                _components.EnterpriseContent,
                { className: styles.content },
                content || children
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'inner-scroll-fixed' },
              _react2.default.createElement(_components.EnterpriseFooter, { className: styles.footer })
            )
          )
        )
      );
    }
  }]);
  return App;
}(_react.Component), _class.propTypes = {
  content: _react.PropTypes.node,
  subHeader: _react.PropTypes.node,
  children: _react.PropTypes.node,
  navBar: _react.PropTypes.object
}, _class.defaultProps = {
  navBar: {}
}, _temp);


var mapStateToProps = function mapStateToProps(state) {
  return {
    navBar: state.app.navBar
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(App);


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.jsx
// module id = 1621
// module chunks = 0